import React from "react";
import { RouterProvider } from "react-router-dom";
import {
  readSentryDsnEnvVar,
  readSentryEnvVar,
} from "@src/cloud-connect/feature-toggles/feature-toggles";
import { AppContainer } from "@components/templates/layouts/app-container/app-container";
import { router } from "@src/routes/routes";
import { ModalsEntryPoint } from "@components/templates/modals-entry-point/modals-entry-point";
import { useAppHook } from "./use-app-hook";
import * as Sentry from "@sentry/browser";
import { LanguageProvider } from "@src/language/language-context";
import { SSEProvider } from "@src/cloud-connect/sse/sse-provider";

interface AppProps {
  useHook?: () => void;
}

export const App = ({ useHook = useAppHook }: AppProps) => {
  useHook();

  Sentry.init({
    dsn: readSentryDsnEnvVar(),
    environment: readSentryEnvVar(),
  });

  return (
    <AppContainer>
      <SSEProvider>
        <RouterProvider router={router} />
        <LanguageProvider>
          <ModalsEntryPoint />
        </LanguageProvider>
      </SSEProvider>
    </AppContainer>
  );
};
